import React from "react";
import { Siren, CalendarClock, Trash2 } from "lucide-react";

export const MarketAlertCard = ({ a, admin, onDelete }) => {
  const isWeekend = a.type === "weekend";
  const Icon = isWeekend ? Siren : CalendarClock;
  const label = isWeekend ? "WEEKEND ALERT" : "CANDELA MENSILE";
  return (
    <div
      data-testid={`market-alert-card-${a.id}`}
      className="bg-gradient-to-br from-amber-500/10 to-[#141414] border border-amber-500/30 rounded-md p-5 relative overflow-hidden flex flex-col"
    >
      <div className="absolute top-0 right-0 w-32 h-32 bg-amber-500/10 blur-3xl rounded-full pointer-events-none" />
      <div className="relative flex flex-col h-full">
        <div className="flex items-center justify-between gap-2 mb-2">
          <span className="inline-flex items-center gap-1.5 text-[11px] font-mono px-2 py-0.5 rounded-full bg-amber-500/15 text-amber-400 border border-amber-500/20">
            <Icon size={12} /> {label}
          </span>
          {admin && (
            <button
              data-testid={`delete-market-alert-${a.id}`}
              onClick={() => onDelete && onDelete(a.id)}
              className="p-1.5 rounded-md text-zinc-500 hover:text-red-400 hover:bg-red-500/10 transition-colors"
              title="Elimina avviso"
            >
              <Trash2 size={15} />
            </button>
          )}
        </div>
        <h3 className="text-base font-semibold text-white">{a.title}</h3>
        <p className="text-sm text-zinc-300 mt-2 whitespace-pre-wrap leading-relaxed flex-1">{a.body}</p>
        <div className="text-[11px] text-zinc-600 mt-4 font-mono">
          {a.created_at && new Date(a.created_at).toLocaleString("it-IT", { timeZone: "Europe/Rome" })}
        </div>
      </div>
    </div>
  );
};
